import React, { useRef } from "react";
import IndexTable from "src/js/components/IndexTable";
import BulkInvoiceModal from "../Invoices/BulkInvoiceModal";
import getInvoicedStatusColumn from "../Invoices/Fortnox/Utilities/getInvoicedStatusColumn";

type QuoteRowsIndexProps = {
	extraHeader?: React.ReactNode;
	onSelectionChangeInclRow?: (items: any[]) => void;
	titleHidden?: boolean;
	backAction?: any;
	onClickRow?: (item: any) => void;
	history?: any;
	location?: any;
	project?: any;
	selectOnRow?: boolean;
	fixedParams?: any;
};

const QuoteRowsIndex = ({
	extraHeader,
	onSelectionChangeInclRow,
	titleHidden,
	backAction,
	onClickRow,
	history,
	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	location,
	project,
	selectOnRow,
	fixedParams,
}: QuoteRowsIndexProps) => {
	const refresh = useRef<any>(null);
	const ref = useRef<any>(null);

	const [isOpenInvoiceStatusModal, setIsOpenInvoiceStatusModal] = React.useState(false);

	const handleOpenInvoiceStatusModal = () => {
		setIsOpenInvoiceStatusModal(true);
	};

	const handleCloseInvoiceStatusModal = () => {
		setIsOpenInvoiceStatusModal(false);
	};

	const promotedBulkActions = [
		{
			content: "Ändra faktureringsstatus",
			onAction: handleOpenInvoiceStatusModal,
		},
	];

	const columns = [
		{
			handle: "DESCRIPTION",
			label: "Beskrivning",
			render: (item) => {
				return item.description;
			},
		},
		{
			handle: "QUOTE",
			label: "Offert",
			render: (item) => {
				return `${item.quote?.title} (${item.quote?.id})`;
			},
		},
		{
			handle: "QUANTITY",
			label: "Antal",
			render: (item) => {
				return item.count;
			},
		},
		{
			handle: "UNIT",
			label: "Enhet",
			render: (item) => {
				return item.unit;
			},
		},
		{
			handle: "amount_to_invoice",
			label: "Att fakturera",
			render: (item) => {
				return item.subtotal;
			},
		},
		getInvoicedStatusColumn(),
	];

	return (
		<>
			<IndexTable
				ref={ref}
				setRefreshHandler={(refreshHandler) => {
					// eslint-disable-next-line react/no-unused-class-component-methods
					refresh.current = refreshHandler;
				}}
				promotedBulkActions={promotedBulkActions}
				selectOnRow={selectOnRow}
				extraHeader={extraHeader}
				onSelectionChangeInclRow={onSelectionChangeInclRow}
				titleHidden={titleHidden}
				backAction={backAction}
				onClickRow={(item) => {
					if (onClickRow) {
						onClickRow(item);
					}
				}}
				history={history}
				title="Offert rader"
				savedSearchHandle="quote_rows"
				resourceUrl="/api/quote_rows.json"
				params={{
					...(fixedParams || {}),
					project_id: project && project.id,
				}}
				resourceHandle="quote_rows"
				// filters={filters}
				resourceName={{
					singular: "offert rad",
					plural: "offer rader",
				}}
				columns={columns}
			/>
			<BulkInvoiceModal
				type="quote_rows"
				ids={ref?.current?.getSelection()}
				open={isOpenInvoiceStatusModal}
				onClose={handleCloseInvoiceStatusModal}
				onSuccess={() => {
					handleCloseInvoiceStatusModal();
					refresh.current();
				}}
			/>
		</>
	);
};
export default QuoteRowsIndex;
